const allowedOrigin = () => {
    const actualOrigin = window.top.location.origin
    const originAllowed = import.meta.env.VITE_ORIGIN_ALLOWED;
    console.log(typeof actualOrigin);
    return originAllowed.includes(actualOrigin);
}

export const setBuildingTab = ({tab}) => {
    console.log(tab)
    window.parent.postMessage({detail: {params: [tab], controller: "edificio", func: "setTabEdificio"}}, "*");
}

export const setImovelTab = ({tab}) => {
    window.parent.postMessage({detail: {params: [tab], controller: "imovel", func: "setTabImovel"}}, "*");
}

export const openCompanyTab = ({ id_contato, nome_contato }) => {
    window.parent.postMessage({detail: {params: [id_contato, nome_contato], controller: "contato", func: "mostrarTabEmpresa"}}, "*");
}

export const openOfficeTab = ({ id_edificio }) => {
    let record = {
        data: {}
    };
    record.data.id_edificio = id_edificio;
    window.parent.postMessage({detail: {params: [record], controller: "edificio", func: "detalhesEdificio"}}, "*");
}

export const openShoppingTab = ({ id_shopping }) => {
    let record = {
        data: {
            id_imovel: null
        }
    };
    record.data.id_shopping = id_shopping;
    window.parent.postMessage({detail: {params: [record], controller: "shopping", func: "detalhesShopping"}}, "*");
}

export const openIndustrialTab = ({ id_imovel }) => {
    let record = {
        data: {}
    };
    record.data.id_imovel = id_imovel;
    window.parent.postMessage({detail: {params: [record], controller: "imovel", func: "detalhesImovel"}}, "*");
}